export default {
  "component.globalHeader.search": "جستجو ",
  "component.globalHeader.search.example1": "مثال 1 را جستجو کنید",
  "component.globalHeader.search.example2": "مثال 2 را جستجو کنید",
  "component.globalHeader.search.example3": "مثال 3 را جستجو کنید",
  "component.globalHeader.help": "کمک",
  "component.globalHeader.notification": "اعلان",
  "component.globalHeader.notification.empty":
    "شما همه اعلان ها را مشاهده کرده اید.",
  "component.globalHeader.message": "پیام",
  "component.globalHeader.message.empty": "شما همه پیام ها را مشاهده کرده اید.",
  "component.globalHeader.event": "رویداد",
  "component.globalHeader.event.empty": "شما همه رویدادها را مشاهده کرده اید.",
  "component.noticeIcon.clear": "پاک کردن",
  "component.noticeIcon.cleared": "پاک شد",
  "component.noticeIcon.empty": "بدون اعلان",
  "component.noticeIcon.view-more": "نمایش بیشتر",
};
